import Meta from "../_data/models/Meta";
import {Action} from "redux-actions";
import {combineReducers} from "redux";
import {clearShopProfile, didAddShopBooth, didReceiveShopBooths, requestShopBooths} from "../shop/actions";
import {Map} from "immutable";



interface BoothCollectionAction {
    ids: Map<number, number>
    meta: Meta,
    loading: boolean
}

export const boothCollectionReducer = combineReducers({
    ids: boothCollectionIds,
    meta: boothCollectionMeta,
    loading: boothCollectionIsLoading,
});


function boothCollectionIds(state: Map<number, number> = Map<number, number>(), action: Action<BoothCollectionAction>) {

    switch (action.type) {
        case didReceiveShopBooths.toString():
            return state.mergeDeep(action.payload.ids);
        case didAddShopBooth.toString():
            return state.mergeDeep(action.payload.ids);
        case clearShopProfile.toString():
            return Map<number, number>();
    }

    return state;
}

function boothCollectionMeta(state: Meta = null, action: Action<BoothCollectionAction>) {

    switch (action.type) {
        case didReceiveShopBooths.toString():
            return action.payload.meta;
    }
    return state;
}

function boothCollectionIsLoading(state: boolean = false, action: Action<any>) {
    switch (action.type) {
        case requestShopBooths.toString():
            return true;
        case didReceiveShopBooths.toString():
            return false;
    }

    return state;
}

export default boothCollectionReducer;


// WEBPACK FOOTER //
// ./app/client/booth/reducers.ts